import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TprComponent } from "./tpr/tpr.component";
import { TprPeersComponent } from "./tpr-peers/tpr-peers.component";
import { TprCompanyComponent } from "./tpr-company/tpr-company.component";
import { TprDocumentModalComponent } from "./tpr-document-modal/tpr-document-modal.component";
import { TprDocumentGridComponent } from "./tpr-document-grid/tpr-document-grid.component";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { Routes, RouterModule } from "@angular/router";

import { NzToolTipModule } from "ng-zorro-antd/tooltip";
import { IconsModule } from "@va/core-library/icons";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "../shared/shared.module";
import { CustomGridModule } from "@va/core-library/custom-grid";
import { ConsensusSummaryComponent } from "./consensus-summary/consensus-summary.component";
import { RatingDistributionComponent } from "./consensus-summary/components/rating-distribution/rating-distribution.component";
import { HighchartsChartModule } from "highcharts-angular";
import { RatingConsensusComponent } from "./consensus-summary/components/rating-consensus/rating-consensus.component";
import { TargetPriceConsensusComponent } from "./consensus-summary/components/target-price-consensus/target-price-consensus.component";
import { ButtonModule } from "@va/core-library/button";
import { TprCompanyBrokerGridComponent } from "./tpr-company-broker-grid/tpr-company-broker-grid.component";
import { TprPeersFilterComponent } from "./tpr-peers-filter/tpr-peers-filter.component";
import { ValuationPageModule } from "src/app/valuation-page/valuation-page.module";
// ant modules
import { NzSkeletonModule } from "ng-zorro-antd/skeleton";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzDropDownModule } from "ng-zorro-antd/dropdown";
import { NzSwitchModule } from "ng-zorro-antd/switch";
import { NzSpinModule } from "ng-zorro-antd/spin";
import { NzTabsModule } from "ng-zorro-antd/tabs";
import { NzCheckboxModule } from "ng-zorro-antd/checkbox";
import { NzPopoverModule } from "ng-zorro-antd/popover";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzMenuModule } from "ng-zorro-antd/menu";
import { TprPeersGridComponent } from "./tpr-peers-grid/tpr-peers-grid.component";
import { TprPeersGridWrapperComponent } from "./tpr-peers-grid-wrapper/tpr-peers-grid-wrapper.component";
import { MatTableModule } from "@angular/material/table";
import { CurrencySelectModule } from "@va/core-library/currency-select";
import { NzIconModule } from "ng-zorro-antd/icon";
import { MatPaginatorModule } from "@angular/material/paginator";
import { TprPeersGridV2Component } from "./tpr-peers-grid-v2/tpr-peers-grid-v2.component";

//pipe
import { SafePipeModule } from "src/app/pipes/safe.pipe.module";

const tprRoutes: Routes = [
  {
    path: "",
    pathMatch: "full",
    component: TprComponent,
    data: {
      title: "Target Price &  Ratings",
    },
  },
  {
    path: "**",
    redirectTo: "/home",
  },
];

@NgModule({
  imports: [RouterModule.forChild(tprRoutes)],
  exports: [RouterModule],
  declarations: [],
})
export class TprRoutingModule {}

@NgModule({
  declarations: [
    TprComponent,
    TprPeersComponent,
    TprCompanyComponent,
    ConsensusSummaryComponent,
    RatingDistributionComponent,
    RatingConsensusComponent,
    TargetPriceConsensusComponent,
    TprCompanyBrokerGridComponent,
    TprDocumentModalComponent,
    TprDocumentGridComponent,
    TprPeersFilterComponent,
    TprPeersGridComponent,
    TprPeersGridWrapperComponent,
    TprPeersGridV2Component,
  ],
  imports: [
    CommonModule,
    NzToolTipModule,
    SharedModule,
    IconsModule,
    FormsModule,
    ReactiveFormsModule,
    TprRoutingModule,
    CustomGridModule,
    InfiniteScrollModule,
    HighchartsChartModule,
    CustomGridModule,
    ValuationPageModule,
    ButtonModule,
    MatTableModule,
    CurrencySelectModule,
    NzSkeletonModule,
    NzModalModule,
    NzDropDownModule,
    NzSwitchModule,
    NzSpinModule,
    NzTabsModule,
    NzCheckboxModule,
    NzMenuModule,
    NzPopoverModule,
    NzButtonModule,
    NzIconModule,
    SafePipeModule,
    MatPaginatorModule,
  ],
  exports: [
    TprPeersGridWrapperComponent,
    TprPeersGridComponent,
    TprPeersGridV2Component,
  ],
})
export class TprModule {}
